import { useEffect, useRef, type ReactNode } from 'react';
import s from './Auth.module.scss';

/**
 * [2026-09-10] 인증 페이지 공용 셸 — evs.com/member/login 식 좌측 다크 패널 + 우측 이미지 split.
 *   각 페이지는 폼/내용을 children으로 넣고, 제목·설명만 전달.
 */
export default function AuthShell({ eyebrow, title, desc, children, image }: {
	eyebrow?: string; title: ReactNode; desc?: ReactNode; children: ReactNode;
	image?: string;   // [2026-09-11] 우측 히어로 이미지 지정(미지정 시 Auth.module.scss 기본). 페이지별 다른 이미지용.
}) {
	// 수직 스크롤 연동 절제된 패럴랙스 — sticky 이미지 프레임(overflow hidden) 안에서 이미지만 미세 드리프트.
	//   transform은 스크롤 핸들러가 담당(등장 fade는 CSS opacity라 충돌 없음). base scale(1.06)로 이동 여유 확보.
	const imgRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		const el = imgRef.current;
		if (!el) return;
		let raf = 0;
		const apply = () => { raf = 0; el.style.transform = `translate3d(0, ${window.scrollY * 0.06}px, 0) scale(1.06)`; };
		const onScroll = () => { if (!raf) raf = requestAnimationFrame(apply); };
		apply();
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => { window.removeEventListener('scroll', onScroll); cancelAnimationFrame(raf); };
	}, []);
	return (
		<div className={s.split}>
			<div className={s.left}>
				<div className={s.leftInner}>
					{eyebrow && <p className={s.eyebrow}>{eyebrow}</p>}
					<h1 className={s.title}>{title}</h1>
					{desc && <p className={s.sub}>{desc}</p>}
					{children}
				</div>
			</div>
			<div className={s.right} aria-hidden>
				<div ref={imgRef} className={s.rightImg}
					style={image ? { backgroundImage: `url(${image})` } : undefined} />
			</div>
		</div>
	);
}
